import React from 'react';
import createSvgIcon from '@mui/material/utils/createSvgIcon.js';

export default createSvgIcon(
  <path d="M12 13.9091L2 8.45455L12 3L22 8.45455L12 13.9091ZM12 17.5455L2.52273 12.3864L4.43182 11.3409L12 15.4773L19.5682 11.3409L21.4773 12.3864L12 17.5455ZM12 21.1818L2.52273 16.0227L4.43182 14.9773L12 19.1136L19.5682 14.9773L21.4773 16.0227L12 21.1818ZM12 11.8409L18.2045 8.45455L12 5.06818L5.79545 8.45455L12 11.8409Z" />,
  'Configuration manager',
);
